<div class="container">
  <div class="header">
    <pdq-heading element="h3">Enable Shopify’s third-party checkout</pdq-heading>
    <pdq-button
      (onClick)="dialogRef.close()"
      iconColor="var(--on-surface-light)"
      variant="ghost"
      icon="close"></pdq-button>
  </div>
  <div class="wrapper">
    <div class="content">
      Our delivery methods can't be added to this store because its Shopify plan doesn't
      <br />
      support third-party checkouts.

      <br /><br />
      <b>To optimize delivery methods for this store’s checkout, pick one:</b>
      <br />
      <ul>
        <li>Switch to an annual Shopify Basic plan</li>
        <li>Upgrade to an Advanced/Plus Shopify plan</li>
        <li>Request that Shopify enable “third-party carrier” on your Shopify Basic plan</li>
      </ul>

      <br />
      <span
        >For more details, read
        <pdq-link external="true" [url]="SHOPIFY_ARTICLE_URL" label="Shopify's help center article about it"></pdq-link
      ></span>
    </div>
  </div>
  <footer>
    <pdq-button label="Chat with Shopify support" (onClick)="onChatWithShopify()"></pdq-button>
    <pdq-button (onClick)="onReviewShopifyPlans()" variant="primary" label="Review Shopify plans"></pdq-button>
  </footer>
</div>
